import React, { useCallback } from 'react';
import { StyledFooterWrapper, StyledParticleJoyLogo, getLinkStyles } from './Footer.styles';
import { useLayoutEngineTranslations } from './Footer.i18n';
import { JOY_ABOUT_URL, JOY_BROWSE_DESIGNS_URL, JOY_HELP_URL } from '@shared/utils/constants';
import { Flex, LinkV2, useTheme } from '@withjoy/joykit';
import { useColorPaletteProvider } from '../../layouts/ColorPaletteProvider/ColorPaletteProvider';
import { getHoverColor } from '@apps/guest/packages/layout-engine/layouts/layout.utils';

const ITEM_NAMES = {
  HELP: 'Help',
  ABOUT: 'About',
  JOY: 'Joy',
  BROWSE_DESIGNS: 'Browse Designs',
};

const Footer: React.FC<{ onButtonClicked?: (item: string) => void }> = props => {
  const { help, about, browseDesigns } = useLayoutEngineTranslations();
  const { colors } = useTheme();
  const { onButtonClicked, ...restProps } = props;
  const { pageFontColor } = useColorPaletteProvider();
  const linkColor = pageFontColor || colors.mono10;
  const linkHoverColor = pageFontColor ? getHoverColor(linkColor) : colors.mono14;

  const handleButtonClicked = useCallback(
    (item: string) => {
      onButtonClicked?.(item);
    },
    [onButtonClicked],
  );

  return (
    <StyledFooterWrapper
      paddingTop={{ _: 6, sm2: 0 }}
      {...restProps}
    >
      <StyledParticleJoyLogo
        onClick={() => handleButtonClicked(ITEM_NAMES.JOY)}
        id="footer2brand-desktop"
        logoColor={linkColor}
        href={'/'}
      />
      <Flex
        flexDirection="row"
        gap={6}
      >
        <LinkV2
          isExternal={true}
          onClick={() => handleButtonClicked(ITEM_NAMES.HELP)}
          {...getLinkStyles(linkColor, linkHoverColor)}
          href={JOY_HELP_URL}
        >
          {help}
        </LinkV2>

        <LinkV2
          isExternal={true}
          onClick={() => handleButtonClicked(ITEM_NAMES.ABOUT)}
          {...getLinkStyles(linkColor, linkHoverColor)}
          href={JOY_ABOUT_URL}
        >
          {about}
        </LinkV2>
        <LinkV2
          isExternal={true}
          onClick={() => handleButtonClicked(ITEM_NAMES.BROWSE_DESIGNS)}
          {...getLinkStyles(linkColor, linkHoverColor)}
          href={JOY_BROWSE_DESIGNS_URL}
        >
          {browseDesigns}
        </LinkV2>
      </Flex>
    </StyledFooterWrapper>
  );
};

Footer.displayName = 'Footer';

export { Footer };
